import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWrench = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.032 21v-3.8a7.69 7.69 0 0 1-4.725-7.1A7.7 7.7 0 0 1 9.032 3v6.07c0 .403.242.766.613.922l1.968.825a1 1 0 0 0 .774-.001l1.958-.823c.37-.157.612-.52.612-.922V3a7.68 7.68 0 0 1 4.736 7.1 7.67 7.67 0 0 1-4.736 7.1V21"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgWrench);
export default ForwardRef;
